import Container from './GalleryBatchEdit.container';
import GalleryBatchEdit from './GalleryBatchEdit';

export default Container(GalleryBatchEdit);
